module.exports = __webpack_public_path__ + "img/2021_P1150088-1.e1701bd7.jpg";